import { useMemo } from 'react'

import { useJscDevelopmentPlanData } from '../../table/hooks/useJscDevelopmentPlan'
import { IOptionsType } from '../types'

const useJscDevelopmentPlan = () => {
  const { data, loading } = useJscDevelopmentPlanData()

  return {
    data: useMemo(() => {
      const options: IOptionsType = [
        {
          value: 'ALL',
          label: 'All',
        },
      ]

      data?.listLocationDevelopmentPlan.nodes.forEach(
        (d: { jobTitle: string }) => {
          if (
            d.jobTitle &&
            !options.some((o) => 'value' in o && o.value === d.jobTitle)
          )
            options.push({
              value: d.jobTitle,
              label: d.jobTitle,
            })
        },
      )

      return options
    }, [data]),
    loading,
  }
}

export default useJscDevelopmentPlan
